import { AppLanguage, getPreferredLanguage } from '../language';

export interface ProductLibraryI18nTemplate {
  ui: {
    actionMyProducts: string;
    dropdownEdit: string;
    dropdownCopy: string;
    dropdownDelete: string;
    actionAddProduct: string;
    productLibraryActionCalculate: string;
    productLibraryFilterAllSensitivity: string;
    productLibraryFilterAllAttributes: string;
    productLibrarySensitivityNormal: string;
    productLibrarySensitivityLow: string;
    productLibrarySensitivityMedium: string;
    productLibrarySensitivityHigh: string;
    productSensitivityRejected: string;
    productSensitivityTooltip: string;
    productAttributeBatteryWeak: string;
    productAttributeBatteryTooltip: string;
    productAttributeMagneticWeak: string;
    productAttributeMagneticTooltip: string;
    productLibraryAttributeBattery: string;
    productLibraryAttributeMagnetic: string;
    productLibrarySearchPlaceholder: string;
    productPageLandingDescription: string;
    actionLoginNow: string;
    productPageLockedTitle: string;
    productPageLockedDescription: string;
    productPageLockedFeatureSave: string;
    productPageLockedFeatureImport: string;
    productPageLockedFeatureSync: string;
    productPageLockedFeatureInventory: string;
    actionOpenAccount: string;
    actionContactSupport: string;
    productEditTitleCreate: string;
    productEditTitleEdit: string;
    productEditActionCalculate: string;
    productEditActionDone: string;
    productEditActionAnalyzing: string;
    productEditNamePlaceholder: string;
    productEditDescriptionPlaceholder: string;
    productEditSectionPackedWeightDimension: string;
    productEditTooltipLimitsTitle: string;
    productEditTooltipWeightTemplate: string;
    productEditTooltipLongestSideTemplate: string;
    productEditTooltipSecondSideTemplate: string;
    productEditTooltipGirthTemplate: string;
    productEditUnitMetric: string;
    productEditUnitImperial: string;
    productEditWeightPlaceholder: string;
    productEditLengthPlaceholder: string;
    productEditWidthPlaceholder: string;
    productEditHeightPlaceholder: string;
    productEditSectionShippingWeight: string;
    productEditVolumetricFormulaLabel: string;
    productEditVolumetricFormulaTemplate: string;
    productEditBillingWeightRuleLabel: string;
    productEditBillingWeightRuleDescription: string;
    productEditVolumetricWeightPrefix: string;
    productEditBillableWeightPrefix: string;
    productEditVolumetricWeightPlaceholder: string;
    productEditBillableWeightPlaceholder: string;
    productEditSectionOtherFeatures: string;
    productEditBatteryTitle: string;
    productEditBatteryNone: string;
    productEditBatteryUnder100: string;
    productEditBatteryOver100Unsupported: string;
    productEditMagneticTitle: string;
    productEditMagneticNone: string;
    productEditMagneticWeak: string;
    productEditMagneticStrongUnsupported: string;
    productEditUnsupported: string;
    productEditPopupPermissionDenied: string;
    productEditSaveFailed: string;
    productEditSaveRetry: string;
    productEditWeightExceedTemplate: string;
    productEditLongestSideExceedTemplate: string;
    productEditSecondSideExceedTemplate: string;
    productEditGirthExceedTemplate: string;
  };
}

export const TEMPLATES: Record<AppLanguage, ProductLibraryI18nTemplate> = {
  zh: {
    ui: {
      actionMyProducts: '我的商品',
      dropdownEdit: '编辑',
      dropdownCopy: '复制',
      dropdownDelete: '删除',
      actionAddProduct: '+ 商品',
      productLibraryActionCalculate: '运费试算',
      productLibraryFilterAllSensitivity: '所有敏感度',
      productLibraryFilterAllAttributes: '所有属性',
      productLibrarySensitivityNormal: '普通',
      productLibrarySensitivityLow: '低敏感',
      productLibrarySensitivityMedium: '中敏感',
      productLibrarySensitivityHigh: '高敏感',
      productSensitivityRejected: '禁运',
      productSensitivityTooltip: '商品敏感度基于你提交的信息初步判断，用于向承运商询价。承运商可能按自身规则重新分类，最终结果以承运商认定为准。',
      productAttributeBatteryWeak: '弱电',
      productAttributeBatteryTooltip: '商品含有容量小于100Wh的电池，将影响物流费用。',
      productAttributeMagneticWeak: '弱磁',
      productAttributeMagneticTooltip: '商品含有弱磁性材料，将影响物流费用。',
      productLibraryAttributeBattery: '带电',
      productLibraryAttributeMagnetic: '带磁',
      productLibrarySearchPlaceholder: '搜索名称、描述、分类、特殊处理说明',
      productPageLandingDescription: '管理一件代发商品信息。',
      actionLoginNow: '立即登录',
      productPageLockedTitle: '管理商品库',
      productPageLockedDescription: '升级到标准账户，开启您的专属商品库。您可以保存常用商品信息，一键导入并快速下单，极大提升处理效率。',
      productPageLockedFeatureSave: '快速保存与查找常用商品',
      productPageLockedFeatureImport: '批量导入商品资料',
      productPageLockedFeatureSync: '一键同步下单流程',
      productPageLockedFeatureInventory: '专属商品库存管理',
      actionOpenAccount: '立即开户',
      actionContactSupport: '联系客服',
      productEditTitleCreate: '新建商品',
      productEditTitleEdit: '编辑商品信息',
      productEditActionCalculate: '运费试算',
      productEditActionDone: '完成',
      productEditActionAnalyzing: '识别中',
      productEditNamePlaceholder: '',
      productEditDescriptionPlaceholder: '新建商品描述或海关编码，获得更精确的估价。',
      productEditSectionPackedWeightDimension: '包装后的重量和尺寸',
      productEditTooltipLimitsTitle: '重量和尺寸限制：',
      productEditTooltipWeightTemplate: '重量 ≤ {max} {unit}',
      productEditTooltipLongestSideTemplate: '最长边 ≤ {max} {unit}',
      productEditTooltipSecondSideTemplate: '次长边 ≤ {max} {unit}',
      productEditTooltipGirthTemplate: '围长（最长边 + 2 x 另外两边） ≤ {max} {unit}',
      productEditUnitMetric: '公制',
      productEditUnitImperial: '英制',
      productEditWeightPlaceholder: '',
      productEditLengthPlaceholder: '长度',
      productEditWidthPlaceholder: '宽度',
      productEditHeightPlaceholder: '高度',
      productEditSectionShippingWeight: '包装后的物流重量 · 自动计算',
      productEditVolumetricFormulaLabel: '体积重公式：',
      productEditVolumetricFormulaTemplate: '长 x 宽 x 高 / {divisor}（{unit}）',
      productEditBillingWeightRuleLabel: '计费重规则：',
      productEditBillingWeightRuleDescription: '计费重取实际重量与体积重中的较大值，用于向承运商询价。承运商可能按自身规则向上取整，最终计费重以承运商认定为准。',
      productEditVolumetricWeightPrefix: '体积重',
      productEditBillableWeightPrefix: '计费重',
      productEditVolumetricWeightPlaceholder: '',
      productEditBillableWeightPlaceholder: '',
      productEditSectionOtherFeatures: '其他特性',
      productEditBatteryTitle: '电池属性',
      productEditBatteryNone: '无电池',
      productEditBatteryUnder100: '电池容量 < 100Wh',
      productEditBatteryOver100Unsupported: '暂不支持电池容量 ≥ 100Wh 的商品',
      productEditMagneticTitle: '磁性属性',
      productEditMagneticNone: '无磁性',
      productEditMagneticWeak: '含有弱磁性材料',
      productEditMagneticStrongUnsupported: '暂不支持含有强磁性材料的商品',
      productEditUnsupported: '暂不支持',
      productEditPopupPermissionDenied: '您的账户等级不足。请联系客服升级至专业卖家以新建和管理商品。',
      productEditSaveFailed: '保存失败',
      productEditSaveRetry: '保存失败，请重试',
      productEditWeightExceedTemplate: '重量不能超过 {max} {unit}',
      productEditLongestSideExceedTemplate: '最长边不能超过 {max} {unit}',
      productEditSecondSideExceedTemplate: '次长边不能超过 {max} {unit}',
      productEditGirthExceedTemplate: '围长（最长边 + 2 x 另外两边）不能超过 {max} {unit}',
    },
  },
  en: {
    ui: {
      actionMyProducts: 'My products',
      dropdownEdit: 'Edit',
      dropdownCopy: 'Copy',
      dropdownDelete: 'Delete',
      actionAddProduct: '+ Product',
      productLibraryActionCalculate: 'Get quote',
      productLibraryFilterAllSensitivity: 'All sensitivities',
      productLibraryFilterAllAttributes: 'All attributes',
      productLibrarySensitivityNormal: 'Normal',
      productLibrarySensitivityLow: 'Low sensitivity',
      productLibrarySensitivityMedium: 'Medium sensitivity',
      productLibrarySensitivityHigh: 'High sensitivity',
      productSensitivityRejected: 'Restricted',
      productSensitivityTooltip: 'Product sensitivity is preliminarily inferred from your inputs for carrier quoting. Carriers may reclassify by their own rules; final classification follows carrier determination.',
      productAttributeBatteryWeak: 'Low battery',
      productAttributeBatteryTooltip: 'This product contains a battery under 100Wh, which may affect shipping fees.',
      productAttributeMagneticWeak: 'Weak magnetic',
      productAttributeMagneticTooltip: 'This product contains weak magnetic material, which may affect shipping fees.',
      productLibraryAttributeBattery: 'Battery',
      productLibraryAttributeMagnetic: 'Magnetic',
      productLibrarySearchPlaceholder: 'Search name, description, categories, handling notes',
      productPageLandingDescription: 'Manage your dropshipping products.',
      actionLoginNow: 'Log in now',
      productPageLockedTitle: 'Manage product library',
      productPageLockedDescription: 'Upgrade to a standard account to unlock your dedicated product library. Save frequently used products, import in bulk, and place orders faster.',
      productPageLockedFeatureSave: 'Quickly save and find frequent products',
      productPageLockedFeatureImport: 'Bulk import product details',
      productPageLockedFeatureSync: 'One-click order sync workflow',
      productPageLockedFeatureInventory: 'Dedicated product inventory management',
      actionOpenAccount: 'Open account',
      actionContactSupport: 'Contact support',
      productEditTitleCreate: 'Add product',
      productEditTitleEdit: 'Edit product',
      productEditActionCalculate: 'Get quote',
      productEditActionDone: 'Done',
      productEditActionAnalyzing: 'Analyzing',
      productEditNamePlaceholder: '',
      productEditDescriptionPlaceholder: 'Add product description or HS code for a more accurate estimate.',
      productEditSectionPackedWeightDimension: 'Packed weight and dimensions',
      productEditTooltipLimitsTitle: 'Weight and size limits:',
      productEditTooltipWeightTemplate: 'Weight <= {max} {unit}',
      productEditTooltipLongestSideTemplate: 'Longest side <= {max} {unit}',
      productEditTooltipSecondSideTemplate: 'Second longest side <= {max} {unit}',
      productEditTooltipGirthTemplate: 'Girth (longest side + 2 x other two sides) <= {max} {unit}',
      productEditUnitMetric: 'Metric',
      productEditUnitImperial: 'Imperial',
      productEditWeightPlaceholder: '',
      productEditLengthPlaceholder: 'Length',
      productEditWidthPlaceholder: 'Width',
      productEditHeightPlaceholder: 'Height',
      productEditSectionShippingWeight: 'Shipping weight after packing · Auto calculated',
      productEditVolumetricFormulaLabel: 'Volumetric weight formula:',
      productEditVolumetricFormulaTemplate: 'L x W x H / {divisor} ({unit})',
      productEditBillingWeightRuleLabel: 'Billable weight rule:',
      productEditBillingWeightRuleDescription: 'Billable weight uses the greater of actual and volumetric weight for rate requests. Carriers may round up differently, and final billable weight follows carrier determination.',
      productEditVolumetricWeightPrefix: 'Volumetric',
      productEditBillableWeightPrefix: 'Billable',
      productEditVolumetricWeightPlaceholder: '',
      productEditBillableWeightPlaceholder: '',
      productEditSectionOtherFeatures: 'Other features',
      productEditBatteryTitle: 'Battery',
      productEditBatteryNone: 'No battery',
      productEditBatteryUnder100: 'Battery capacity < 100Wh',
      productEditBatteryOver100Unsupported: 'Products with battery capacity >= 100Wh are not supported',
      productEditMagneticTitle: 'Magnetic',
      productEditMagneticNone: 'Non-magnetic',
      productEditMagneticWeak: 'Contains weak magnetic material',
      productEditMagneticStrongUnsupported: 'Products with strong magnetic material are not supported',
      productEditUnsupported: 'Not supported',
      productEditPopupPermissionDenied: 'Your account level is insufficient. Contact support to upgrade before creating and managing products.',
      productEditSaveFailed: 'Save failed',
      productEditSaveRetry: 'Save failed, please try again',
      productEditWeightExceedTemplate: 'Weight cannot exceed {max} {unit}',
      productEditLongestSideExceedTemplate: 'Longest side cannot exceed {max} {unit}',
      productEditSecondSideExceedTemplate: 'Second longest side cannot exceed {max} {unit}',
      productEditGirthExceedTemplate: 'Girth (longest side + 2 x other two sides) cannot exceed {max} {unit}',
    },
  },
};

export const PRODUCT_LIBRARY_NAMESPACE = 'productLibrary';

export const PRODUCT_LIBRARY_RESOURCE_KEY = 'template';

export const PRODUCT_LIBRARY_I18N_RESOURCES: Record<
  AppLanguage,
  Record<typeof PRODUCT_LIBRARY_RESOURCE_KEY, ProductLibraryI18nTemplate>
> = {
  zh: {
    [PRODUCT_LIBRARY_RESOURCE_KEY]: TEMPLATES.zh,
  },
  en: {
    [PRODUCT_LIBRARY_RESOURCE_KEY]: TEMPLATES.en,
  },
};

export const getProductLibraryTemplate = (
  language: AppLanguage = getPreferredLanguage(),
): ProductLibraryI18nTemplate => TEMPLATES[language] || TEMPLATES.zh;

export const formatWithTemplate = (
  template: string,
  values: Record<string, string | number>,
): string => {
  return Object.entries(values).reduce((result, [key, value]) => {
    return result.replace(new RegExp(`\\{${key}\\}`, 'g'), String(value));
  }, template);
};
